import React, { Fragment, useMemo } from "react";
import htmlParser from "he";
import { capitalizeFirstCharacter, personalizeResponse } from "_helpers";
import moment from "moment-timezone";
import { CircularProgress } from "@mui/material";
import ProactiveMetricsMessageIframe from "./Utilities/ProactiveMetricsMessageIframe";
import ProactiveMetricMessageShopify from "./Utilities/ProactiveMetricMessageShopify";
import { isShopifyAndFirstIncomingMessage } from "./ProactiveMetricsDetailUtil";
import styles from "./Utilities/styles.module.css";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";

const ProactiveMetricsConversation = ({
  message,
  loadingConversation,
  index,
  messageSource,
  isFirstIncomingMessaging,
  source,
  isFirstOutgoingMessaging,
  proactiveMsgSocialEngagement,
}) => {
  const messageAuthor = message?.authorName;
  const zone_name = moment.tz.guess();
  const timezone = moment.tz(zone_name).zoneAbbr();
  const dateCreated = message?.dateCreatedFromSource || message?.dateCreated;
  const text = htmlParser.decode(
    personalizeResponse(message.text, messageAuthor, "", null)
  );

  const engagements = useMemo(() => {
    if (proactiveMsgSocialEngagement) {
      return proactiveMsgSocialEngagement.reduce(
        (a, b) => {
          return {
            likes: a.likes + Number(b?.likes || 0),
            replies: a.replies + Number(b?.replies || 0),
            follows: a.follows + Number(b?.follows || 0),
          };
        },
        { likes: 0, replies: 0, follows: 0 }
      );
    }
  }, [proactiveMsgSocialEngagement]);

  return (
    <Fragment>
      {loadingConversation && (
        <div className={styles.msgListLoaderContainer}>
          <div className={styles.msgListInner}>
            <CircularProgress sx={{ color: "#003300" }} />
          </div>
        </div>
      )}

      {!loadingConversation && (
        <>
          {isShopifyAndFirstIncomingMessage(
            messageSource,
            isFirstIncomingMessaging
          ) ? (
            <ProactiveMetricMessageShopify
              message={message}
              messageAuthor={messageAuthor}
            />
          ) : (
            <div className={styles.conversationContainer}>
              <div className="md-msg-container">
                <div className="conversation-item-container">
                  <div className="conversation-item-row">
                    <div className={styles.msgMetaDetails}>
                      <div className={styles.msgAuthor}>{messageAuthor}</div>
                      <div className={styles.metricsDetailDateTime}>
                        <span className="metrics-detail-date">
                          {capitalizeFirstCharacter(
                            moment.utc(dateCreated).fromNow()
                          )}
                          {`(${moment(dateCreated).format(
                            "MMMM Do YYYY HH:mm"
                          )} ${timezone})`}
                        </span>
                      </div>
                    </div>
                    <div
                      className={`${styles["metricsDetailFullMsg"]} ${
                        message.direction.toLowerCase() === "outgoing"
                          ? styles.outgoingMsg
                          : ""
                      }`}
                    >
                      <ProactiveMetricsMessageIframe
                        text={text}
                        index={index}
                        messageSource={source}
                      />
                      {isFirstOutgoingMessaging && (
                        <div className={styles.engagementContainer}>
                          {engagements?.likes > 0 && (
                            <div className={styles.engagementItem}>
                              <FavoriteBorderIcon fontSize={"20px"} />
                              <p className={styles.engagementCount}>
                                {engagements.likes}
                              </p>
                            </div>
                          )}

                          {engagements?.replies > 0 && (
                            <div className={styles.engagementItem}>
                              <ChatBubbleOutlineIcon fontSize={"20px"} />
                              <p className={styles.engagementCount}>
                                {engagements.replies}
                              </p>
                            </div>
                          )}

                          {engagements?.follows > 0 && (
                            <div className={styles.engagementItem}>
                              <PersonAddAltIcon fontSize={"20px"} />
                              <p className={styles.engagementCount}>
                                {engagements.follows}
                              </p>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </Fragment>
  );
};

export default ProactiveMetricsConversation;
